import * as React from 'react';

import Button from '../../atoms/button';
import { CloseCross } from '../../atoms/icons';

const DrawerCloseButton = ({
  size,
  variant,
  type,
  shape,
  fill,
  width,
  height,
  onClick,
  className,
}) => (
  <Button
    size={size}
    variant={variant}
    as={type}
    shape={shape}
    fill={fill}
    onClick={onClick}
    className={className}
  >
    <CloseCross width={width} height={height} />
  </Button>
);

export default DrawerCloseButton;
